<template>
  <div>
    <card>
        <div class="row" style="margin-left:5px;margin-bottom:10px">
             <button @click="showSearch = !showSearch" class="btn float-left" type="button" style="margin-top:10px;background:#00467f">Cerca Cliente</button>
        </div>
        <b-modal v-model="showSearch"  size="md">
            <template #modal-header="{ close }">
                <b-button size="sm"  style="background:#00467f;" @click="close()">X</b-button>
            </template>
            <template>
                <h3 style="color:black">Cerca cliente</h3>
                <form>
                    <div class="row">
                        <div class="col">
                            <label for="codice_fiscale"><strong>CODICE FISCALE</strong></label>
                            <input class="form-control" type="codice_fiscale" placeholder="codice_fiscale" name="codice_fiscale" v-model="codice_fiscale_search" v-on:change="cercaInfo()">
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <label for="denominazione"><strong>DENOMINAZIONE </strong></label>
                            <input class="form-control" type="denominazione" placeholder="denominazione" name="denominazione" v-model="denominazione_search" v-on:change="cercaInfo()">
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <label for="partita_iva"><strong>PARTITA IVA</strong></label>
                            <input class="form-control" type="text" placeholder="partita_iva" name="partita_iva" v-model="partita_iva_search" v-on:change="cercaInfo()">
                        </div>
                    </div>
                </form> 
                <div v-show="showRisultati">
                    <div v-if="cerca_info.length>0">
                        <table class="table tablesorter" style="text-align: center;">
                          <thead>
                            <tr>
                              <th>AZIENDA</th>
                              <th>CF</th>
                              <th>P. IVA</th>
                              <th>SEDE</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(valori,index) in cerca_info" v-bind:key="valori.ID">
                              <td style="text-decoration:underline"><a v-on:click="compilaForm(index)">{{valori.name}}</a></td>
                              <td>{{valori.crm_cf_c}}</td>
                              <td>{{valori.crm_piva_c}}</td>
                              <td>{{valori.billing_address_street}}, {{valori.billing_address_city}} ({{valori.billing_address_state}}) {{valori.billing_address_postalcode}}</td><!--infoAzienda.billing_address_street + ", " + infoAzienda.billing_address_city + " (" + infoAzienda.billing_address_state + ") " +infoAzienda.billing_address_postalcode -->
                            </tr>
                          </tbody>
                        </table>
                      </div>
                </div>
            </template>
            <template #modal-footer="{ cancel }">
                <span style="padding-left:40px;"><b-button size="sm" variant="danger" @click="cancel()">CHIUDI</b-button></span>
                <span style="padding-right:40px;"><b-button size="sm"  style="background:#00467f;" @click="cerca()">CERCA</b-button></span>
            </template>
        </b-modal>
         <h3>Dati Identificativi</h3>
        <hr>
        <form>
            <div class="form-row">
                <div class="form-group col-md">
                    <label for="denominazione_cliente">Denominazione cliente</label>
                    <input type="text" class="form-control" v-model="denominazione_cliente">
                </div>
            </div>
            <div class="form-row">
                <div class="form-group col-md-4">
                    <label for="nuovo_cliente">Nuovo cliente</label>
                    <input type="radio" class="form-control" id="nuovo_cliente" value="nuovo_cliente" v-model="value_cliente">
                </div>
                <div class="form-group col-md-4">
                    <label for="gia_cliente">Cliente già identificato in relazione ad un precedente incarico professionale</label>
                    <input type="radio" class="form-control" id="gia_cliente" value="gia_cliente" v-model="value_cliente">
                </div>
                <div class="form-group col-md-4">
                    <label for="necessari_dati">Necessaria/opportuna una nuova identificazione pe variazione e/o verifica dei dati Identificativi</label>
                    <input type="radio" class="form-control" id="necessari_dati" value="necessari_dati" v-model="value_cliente">
                </div>
            </div>
            <div class="form-row">
                <div class="form-group col-md">
                    <label for="responsabile_identificazione">Soggetto responsabile dell'identificazione</label>
                    <input type="text" class="form-control" v-model="responsabile_identificazione">
                </div>
            </div>
            <h4 style="text-align:left">Valore della prestazione professionale</h4>
            <div class="form-row">
                <div class="form-group col-md-4">
                    <label for="responsabile_identificazione">Euro</label>
                    <input type="checkbox" class="form-control" id="necessari_dati" v-model="necessari_dati">
                </div>
                <div class="form-group col-md-4">
                    <label for="indeterminato">indeterminato/non determinabile</label>
                    <input type="checkbox" class="form-control" id="indeterminato" v-model="indeterminato">
                </div>
            </div>
            <h4 style="text-align:left">Operazione</h4>
            <div class="form-row">
                <div class="form-group col-md-3">
                    <label for="data">Data</label>
                    <input type="date" class="form-control" v-model="data">
                </div>
                <div class="form-group col-md-3">
                    <label for="data">Importo</label>
                    <input type="number" class="form-control" v-model="importo">
                </div>
                <div class="form-group col-md-3">
                    <label for="mezzi_pagamento">Mezzi di pagamento utilizzati</label>
                    <input type="text" class="form-control" v-model="mezzi_pagamento">
                </div>
                <div class="form-group col-md-3">
                    <label for="documentazione">Documentazione</label>
                    <input type="text" class="form-control" v-model="documentazione">
                </div>
            </div>
            <h3>2)Dati relativi al Cliente</h3>
            <div class="form-row">
                <div class="form-group col-md-4">
                    <label for="cognome">Cognome</label>
                    <input type="text" class="form-control" v-model="cognome">
                </div>
                <div class="form-group col-md-4">
                    <label for="nome">Nome</label>
                    <input type="text" class="form-control" v-model="nome">
                </div>
                <div class="form-group col-md-4">
                    <label for="codice_fiscale">Codice Fiscale:</label>
                    <input type="text" class="form-control" v-model="codice_fiscale">
                </div>
            </div>
            <div class="form-row">
                <div class="form-group col-md">
                    <label for="carica_poteri">Carica/poteri rappresentanza</label>
                    <input type="text" class="form-control" v-model="carica_poteri">
                </div>
            </div>
            <div class="form-row">
                <div class="form-group col-md-6">
                    <label for="poteri_verificati">Poteri rappresentanza verificati tramite</label>
                    <input type="text" class="form-control" v-model="poteri_verificati">
                </div>
                <div class="form-group col-md-6">
                    <label for="natura_giuridica">Natura giuridica:</label>
                    <input type="text" class="form-control" v-model="natura_giuridica">
                </div>
            </div>
            <h4 style="text-align:left">Con riferimento alla societ/ente</h4>
             <div class="form-row">
                <div class="form-group col-md-3">
                    <label for="denominazione_ragione_sociale">Denominazione/ragione sociale</label>
                    <input type="text" class="form-control" v-model="denominazione_ragione_sociale">
                </div>
                <div class="form-group col-md-3">
                    <label for="codice_fiscale_azienda">Codice fiscale</label>
                    <input type="text" class="form-control" v-model="codice_fiscale_azienda">
                </div>
                <div class="form-group col-md-3">
                    <label for="sede_legale">Sede legale</label>
                    <input type="text" class="form-control" v-model="sede_legale">
                </div>
                <div class="form-group col-md-3">
                    <label>altri documenti da caricare</label>
                </div>
            </div>
            
            <h3 style="text-align:left">2)Dati relativi ai titolari effettivi</h3>
            <div class="form-row">
                <div class="form-group col-md-4">
                    <label for="cognome_titolare">Cognome</label>
                    <input type="text" class="form-control" v-model="cognome_titolare">
                </div>
                <div class="form-group col-md-4">
                    <label for="nome_titolare">Nome</label>
                    <input type="text" class="form-control" v-model="nome_titolare">
                </div>
                <div class="form-group col-md-4">
                    <label for="codice_fiscale_titolare">Codice fiscale</label>
                    <input type="text" class="form-control" v-model="codice_fiscale_titolare">
                </div>
            </div>
            <div class="form-row">
                <div class="form-group col-md-4">
                    <label for="cognome_titolare">Cognome</label>
                    <input type="text" class="form-control" v-model="cognome_titolare">
                </div>
                <div class="form-group col-md-4">
                    <label for="nome_titolare">Nome</label>
                    <input type="text" class="form-control" v-model="nome_titolare">
                </div>
                <div class="form-group col-md-4">
                    <label for="codice_fiscale_titolare">Codice fiscale</label>
                    <input type="text" class="form-control" v-model="codice_fiscale_titolare">
                </div>
            </div>

            <h4 style="text-align:left">Dati acquisiti e verificati tramite</h4>
            <div class="form-row">
                <div class="form-group col">
                    <label><input type="checkbox" class="form-control" v-model="dichiarazione_antiriciclaggio"> dichiarazione antiriciclaggio resa dal CLiente ex. art. 22 D.Lgs.231/2007</label>
                </div>
                 <div class="form-group col">
                    <label><input type="checkbox" class="form-control" v-model="estratti_pubblici_registri"> estratti da pubblici registri</label>
                </div>
                 <div class="form-group col">
                    <label><input type="checkbox" class="form-control" v-model="estratti_elenchi"> estratti da elenchi, atti, documenti conoscibili da chiunque</label>
                </div>
            </div>
            <div class="form-row">
               
            </div>
            <div class="form-row">
               
            </div>

            <h3 style="text-align:left">3)Scopo, natura e altri dati della prestazione professionale</h3>
            <h4 style="text-align:left">PROFILO</h4>
            <div class="form-row">
                <div class="form-group col">
                    <label><input type="checkbox" class="form-control"> dichiarazione antiriciclaggio resa dal CLiente ex. art. 22 D.Lgs. 231/2007</label>
                </div>
            </div>
            <div class="form-row">
                <div class="form-group col">
                    <label><input type="checkbox" class="form-control"> mandato professionale</label>
                </div>
            </div>
            <h4 style="text-align:left">ADEGUATA VERIFICA</h4>
            <div class="form-row">
                <div class="form-group col">
                    <label><input type="radio" v-model="adeguata_verifica" value="ordinaria" class="form-control">ORDINARIA</label>
                </div>
                <div class="form-group col">
                    <label><input type="radio" v-model="adeguata_verifica" value="semplificata" class="form-control">SEMPLIFICATA</label>
                </div>
                <div class="form-group col">
                    <label><input type="radio" v-model="adeguata_verifica" value="rafforzata" class="form-control">RAFFORZATA</label>
                </div>
            </div>
            <h4 style="text-align:left">DATA DI RIFERIMENTO</h4>
             <div class="form-row">
                <div class="form-group col-2">
                    <input type="checkbox" class="form-control"> <label>Data di riferimento del fascicolo</label>
                </div>
                <div class="form-group col-10">
                    <input type="text" class="form-control">
                </div>
            </div>
            <div class="form-row">
               <div class="form-group col-2">
                    <input type="checkbox" class="form-control"> <label>Data di aggiornamento del contenuto del fascicolo</label>
                </div>
                <div class="form-group col-10">
                    <input type="text" class="form-control">
                </div>
            </div>

            <h3>4) Controllo costante</h3>
            <div class="form-row">
                Risultato sintetico della valutazione del “rischio effettivo” relativo al cliente e alla prestazione richiesta risultante da apposita scheda di valutazione (vd. Allegato AV.1) <br>
                (non/poco/abbastanza/molto significativo)
            </div>

         
        </form>
        <button class="btn float-right" type="button" v-on:click="salvaValoriDati()" style="margin-top: 10px;background:#00467f">Salva</button>
        <!-- <button class="btn float-right" type="button" v-on:click="salvaValoriResidenza()" style="margin-top: 10px;background:#00467f">Salva</button> -->
       
    </card>
  </div>
</template>
<script>
import axios from 'axios';
import Card from '@/components/Cards/Card.vue';
import Services from '@/services/Services';
import AntiriciclaggioServices from '@/services/AntiriciclaggioServices';

export default {
    components: {
        Card
    },

    data() {
        return {
            codice_fiscale: null,
            p_iva: null,
            nome: null,
            attivita_svolta: null,
            natura_guiridica: null,
            data_fine_rapporto: null,
            nuovo_cliente: null,
            
            indirizzo: null,
            comune: null,
            cap: null,
            provincia: null,


            value_cliente: 'nuovo_cliente',
            adeguata_verifica: 'ordinaria',

            cerca_info: [],
            showSearch: false,
            showRisultati: false,
            denominazione_search: null,
            codice_fiscale_search: null,
            partita_iva_search: null,

            access_token: null,
            token_response: [],
            urlRichieste: 'https://sviluppoallergeni.confcom.it/',

            allClienti: [],
            cliente: []
        }
    },
    methods: {
        cercaInfo: async function() {
            let errore = 0;
            //const token = localStorage.getItem('access_token');
            await axios.get(
                this.urlRichieste + 'azienda?filter=true&name='+this.denominazione_search+'&CF='+this.codice_fiscale_search+'&piva='+this.partita_iva_search,
                //'https://sviluppoallergeni.confcom.it/azienda?filter=true&name='+this.cerca_zienda+'&CF='+this.cerca_codice_fiscale+'&piva='+this.cerca_p_iva, 
                {
                    headers: {
                    'Content-type': 'application/json',
                    'Authorization': `Bearer ${this.access_token}`
                }
            }).then(response => { this.cerca_info = response.data})
            .catch( function (error) {
                // handle error
                if(error.response.status == 401){
                errore = error.response.status;
                }
            })
            if (errore == 401) {
                let value = await Services.refreshTokenFunction();
                if (value) { await this.cercaInfo(); }
            }
            this.showRisultati = true;
        },

        caricaCliente: async function(id) {
            let errore = 0;
            await AntiriciclaggioServices.getCliente(id)
            .then(response => { this.cliente= response.data})
            .catch( function (error) {
                if(error.response.status == 401){
                    errore = error.response.status;
                }
            });
            if (errore == 401) {
                let value = await Services.refreshTokenFunction();
                if (value) { await this.caricaCliente(id); }
            }
            console.log(`cliente:`);
            console.log(this.cliente);
            /*
             CF: this.codice_fiscale, PIVA: this.p_iva, DENOMINAZIONE: this.nome, ATTIVITA_SVOLTA: this.attivita_svolta, NATURA_GIURIDICA: this.natura_giuridica, 
                DATA_FINE_RAPPORTO: this.data_fine_rapporto, NUOVO_CLIENTE: this.nuovo_cliente, INDIRIZZO: this.indirizzo, COMUNE: this.comune, CAP: this.cap, PROVINCIA: this.provincia
            */
            this.codice_fiscale = this.cliente[0].CF;
            console.log(`codice fiscale: ${this.codice_fiscale}`);
            this.p_iva = this.cliente[0].PIVA;
            this.nome = this.cliente[0].DENOMINAZIONE;
            this.attivita_svolta = this.cliente[0].ATTIVITA_SVOLTA;
            this.natura_guiridica = this.cliente[0].NATURA_GIURIDICA
            this.data_fine_rapporto = this.cliente[0].DATA_FINE_RAPPORTO;
            this.indirizzo = this.cliente[0].INDIRIZZO;
            this.comune = this.cliente[0].COMUNE;
            this.cap = this.cliente[0].CAP;
            this.provincia = this.cliente[0].PROVINCIA;

        },

        getAllClienti: async function() {
            let errore = 0;
            await AntiriciclaggioServices.getAllClienti()
            .then(response => { this.allClienti= response.data})
            .catch( function (error) {
                if(error.response.status == 401){
                    errore = error.response.status;
                }
            });
            if (errore == 401) {
                let value = await Services.refreshTokenFunction();
                if (value) { await this.getAllClienti(); }
            }
            console.log(`allClienti:`);
            console.log(this.allClienti);
        },

        salvaValoriDati: async function() {
            let dati = [];
            console.log(`nuovo_cliente = ${this.nuovo_cliente}`)
            dati.push({ 
                CF: this.codice_fiscale, PIVA: this.p_iva, DENOMINAZIONE: this.nome, ATTIVITA_SVOLTA: this.attivita_svolta, NATURA_GIURIDICA: this.natura_giuridica, 
                DATA_FINE_RAPPORTO: this.data_fine_rapporto, NUOVO_CLIENTE: this.nuovo_cliente, INDIRIZZO: this.indirizzo, COMUNE: this.comune, CAP: this.cap, PROVINCIA: this.provincia
            });
            let datiJSON=JSON.stringify(dati[0]);
            let salvaValori = [];
            let errore = 0; 
            await AntiriciclaggioServices.createCliente(datiJSON)
            .then(response => { salvaValori= response.data})
            .catch( function (error) {
                if(error.response.status == 401){
                    errore = error.response.status;
                }
            });
            if (errore == 401) {
                let value = await Services.refreshTokenFunction();
                if (value) { await this.salvaValoriDati(); }
            }
            console.log(`salvaValori response`);
            console.log(salvaValori);
            let path = 'anagrafica-soggetti?idCliente=' + salvaValori.ID;
            this.$router.push({
                path: path
            }) 
        },

        main: async function() {
            axios.defaults.withCredentials = true;
            this.access_token = localStorage.getItem('access_token');
            try {
                await this.getAllClienti();
            } catch (error) {
                console.log(`error try/catch = ${error}`);
                if (error.response.status == 401) {
                await Services.refreshTokenFunction();
                }
            }
        }
    },
    
    mounted() {
        this.main();
    }
};
</script>
<style>
span {
  font-size: 100%;
}
</style>
